// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__IVgjI","error":"Textarea_error__X7qU9","readonly":"Textarea_readonly__1zvb5","disabled":"Textarea_disabled__1rojF"};